const brand = "PELUCA";
const baseUrl = "https://peluca-79e344313ea6.herokuapp.com";
const baseUrlApi = "https://peluca-79e344313ea6.herokuapp.com/api";

export const config = {
  brand,
  baseUrl,
  baseUrlApi,
  defaultUserImage:
    "https://static.vecteezy.com/system/resources/previews/005/544/718/non_2x/profile-icon-design-free-vector.jpg",
  imgbbApiKey: "f369e564a35464c187abaecc81d252ab",
  email: "info@peluca.com",
  phone: "+1 (123) 456-7890",
  address: "123 Main St, City, Country",
  socialMedia: {
    facebook: "https://facebook.com/peluca",
    twitter: "https://twitter.com/peluca",
    instagram: "https://instagram.com/peluca",
    linkedin: "https://linkedin.com/company/peluca",
  },
  theme: {
    logo: "/logo-peluca.svg",
    brandLogo: "logo-peluca.svg",
    colors: {
      primaryColor: "#FF5722",
      secondaryColor: "#424242",
      tertiaryColor: "#FFC107",
      quaternaryColor: "#212121",
      textMenuColor: "#FFFFFF",
      textMenuHoverColor: "#FF9800",
    },
  },
  mercadopago: {
    clientId: "99922095",
    redirectUrl: baseUrl + "/mercadopago/callback",
  },
  subscription: {
    price: 9.90,
    billingCycle: "monthly",
    conversionRate: 1500,
  },
};
